(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bendito-product"]) return;
  try {
    
  if (!customElements.get('bendito-product')) {
    class BenditoProduct extends HTMLElement {
      connectedCallback() {
        this.variants = JSON.parse(this.querySelector('[data-bp-variants]').textContent);
        this.optionSets = [...this.querySelectorAll('[data-bp-option]')];
        this.sizeIndex = this.optionSets.findIndex((set) => set.classList.contains('bp__option--size'));
        this.barToggles = [...this.querySelectorAll('[data-bp-bar-toggle]')];
        this.menu = this.querySelector('[data-bp-menu]');
        this.menuLists = [...this.querySelectorAll('[data-bp-menu-list]')];
        this.slides = [...this.querySelectorAll('[data-bp-slide]')];
        this.thumbs = [...this.querySelectorAll('[data-bp-thumb]')];
        this.dots = [...this.querySelectorAll('.bp__dot')];
        this.media = this.querySelector('[data-bp-media]');
        this.bar = this.querySelector('[data-bp-bar]');
        this.form = this.querySelector('[data-bp-form]');
        this.status = this.querySelector('[data-bp-status]');
        this.selected = this.optionSets.map((set) => set.querySelector('.is-selected')?.dataset.value ?? null);
        this.desktop = window.matchMedia('(min-width: 990px)');

        // Botones de color y talla de la página
        this.optionSets.forEach((set, index) => {
          set.addEventListener('click', (event) => {
            const button = event.target instanceof Element && event.target.closest('.bp__value');
            if (button) this.select(index, button.dataset.value);
          });
        });

        // Barra flotante (celular): cada botón abre su panel glass con las opciones
        this.barToggles.forEach((toggle) => {
          toggle.addEventListener('click', () => {
            const index = Number(toggle.dataset.bpBarToggle);
            if (this.openMenuIndex === index) this.closeMenu();
            else this.openMenu(index);
          });
        });
        this.menuLists.forEach((list) => {
          list.addEventListener('click', (event) => {
            const button = event.target instanceof Element && event.target.closest('.bp__value');
            if (!button) return;
            this.select(Number(list.dataset.bpMenuList), button.dataset.value);
            setTimeout(() => this.closeMenu(), 160);
          });
        });
        document.addEventListener('pointerdown', (event) => {
          if (this.openMenuIndex == null || !(event.target instanceof Element)) return;
          if (event.target.closest('[data-bp-menu], [data-bp-bar-toggle]')) return;
          this.closeMenu();
        });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.closeMenu();
        });

        this.querySelectorAll('[data-bp-atc]').forEach((button) => button.addEventListener('click', () => this.add(button)));

        // Miniaturas: llevan a la foto
        this.thumbs.forEach((thumb) => thumb.addEventListener('click', () => this.goTo(Number(thumb.dataset.bpThumb))));

        this.index = 0;
        const thumbList = this.querySelector('.bp__thumbs');
        if (thumbList && 'ResizeObserver' in window) {
          const check = () => thumbList.classList.toggle('is-overflowing', thumbList.scrollHeight > thumbList.clientHeight + 1);
          new ResizeObserver(check).observe(thumbList);
        }
        this.relocateApps();
        this.setupSizeChart();
        this.setupZoom();
        this.watchSlides();
        this.setupSwipe();
        this.watchForm();
        this.update(false);
        // Si la página abre con una variante elegida (?variant=), el carrusel del celular empieza en su foto
        const startMedia = this.variantMedia();
        const startIndex = startMedia ? this.slides.findIndex((slide) => slide.dataset.mediaId === String(startMedia)) : -1;
        if (startIndex > 0 && !this.desktop.matches) requestAnimationFrame(() => this.slideTo(startIndex, false));
      }

      // Las apps (KiwiSizing, fecha de envío, etc.) se insertan junto al formulario de compra de la derecha.
      // Todo lo que no es de esta sección se pasa a la columna izquierda, debajo de los bloques.
      relocateApps() {
        const target = this.querySelector('[data-bp-apps]');
        const buy = this.querySelector('.bp__col--buy');
        if (!target || !buy) return;
        const keep = (el) =>
          [...el.classList].some((name) => name.startsWith('bp')) ||
          el.matches('script, style, link, input, template, noscript, shopify-accelerated-checkout, .shopify-payment-button, [data-shopify], [data-bp-keep]');
        // Cada app va al lugar de su bloque en el editor (los bloques de app que salen vacíos), en orden
        const slots = [...this.querySelectorAll('.bp__block--app')].filter((slot) => slot.offsetHeight < 2);
        let last = null;
        const move = () => {
          buy.querySelectorAll(':scope .bp__sticky > *, :scope .bp__form > *, :scope .bp__dynamic-checkout > *').forEach((el) => {
            if (keep(el)) return;
            const slot = slots.shift() || last || target;
            slot.append(el);
            last = slot;
          });
        };
        move();
        new MutationObserver(move).observe(buy, { childList: true, subtree: true });
      }

      // Liga "Tabla de tallas" junto a Talla: abre la página/imagen elegida o, si no hay, la tabla de la app (KiwiSizing, etc.)
      setupSizeChart() {
        const link = this.querySelector('[data-bp-size-chart]');
        if (!link) return;
        const dialog = this.querySelector('[data-bp-size-dialog]');
        const appLink = () =>
          [...this.querySelectorAll('.bp__block--app a, .bp__block--app button, .bp__apps a, .bp__apps button, .bp__block--app [role="button"], .bp__apps [role="button"]')].find(
            (el) => /size|talla|medida/i.test(el.textContent)
          );
        const hideAppLink = this.hasAttribute('data-hide-app-size-link');
        const sync = () => {
          const found = appLink();
          link.hidden = !dialog && !found;
          if (found && hideAppLink) found.closest('.bp__block--app > *, .bp__apps > *')?.classList.add('bp__visually-hidden');
        };
        sync();
        new MutationObserver(sync).observe(this.querySelector('.bp__col--info'), { childList: true, subtree: true });
        // Algunas apps tardan en pintarse
        setTimeout(sync, 1500);
        setTimeout(sync, 4000);

        link.addEventListener('click', () => {
          if (dialog) {
            dialog.showModal();
            return;
          }
          appLink()?.click();
        });
        dialog?.addEventListener('click', (event) => {
          if (event.target === dialog || event.target.closest('[data-bp-dialog-close]')) dialog.close();
        });
      }

      // Zoom a pantalla completa. Compu: clic para acercar y la foto sigue al mouse.
      // Celular: pellizcar con dos dedos o doble toque para acercar, deslizar para cambiar de foto, deslizar hacia abajo para cerrar.
      setupZoom() {
        const dialog = this.querySelector('[data-bp-zoom]');
        const items = this.slides.filter((slide) => slide.dataset.zoomSrc);
        if (!dialog || !items.length || typeof dialog.showModal !== 'function') return;
        this.classList.add('bp--zoomable');
        const stage = dialog.querySelector('[data-bp-zoom-stage]');
        const img = dialog.querySelector('[data-bp-zoom-img]');
        const count = dialog.querySelector('[data-bp-zoom-count]');
        const thumbList = dialog.querySelector('[data-bp-zoom-thumbs]');
        const thumbs = [...dialog.querySelectorAll('[data-bp-zoom-thumb]')];
        dialog.classList.toggle('is-single', items.length < 2);
        dialog.classList.toggle('has-thumbs', items.length > 1 && thumbs.length > 1);

        const MAX = 3;
        const pointers = new Map();
        let index = 0;
        let openedAt = 0;
        let s = 1;
        let x = 0;
        let y = 0;
        let gesture = null;
        let lastTap = 0;

        const local = (event) => {
          const rect = stage.getBoundingClientRect();
          return { x: event.clientX - rect.left - rect.width / 2, y: event.clientY - rect.top - rect.height / 2 };
        };
        const bounds = () => ({
          x: Math.max(0, (img.offsetWidth * s - stage.clientWidth) / 2),
          y: Math.max(0, (img.offsetHeight * s - stage.clientHeight) / 2),
        });
        const clamp = () => {
          const b = bounds();
          x = Math.max(-b.x, Math.min(b.x, x));
          y = Math.max(-b.y, Math.min(b.y, y));
        };
        const render = (animate) => {
          img.style.transition = animate ? 'transform 0.3s cubic-bezier(0.2, 0.8, 0.2, 1), opacity 0.3s ease' : 'none';
          img.style.transform = `translate3d(${x}px, ${y}px, 0) scale(${s})`;
          dialog.classList.toggle('is-zoomed', s > 1.01);
        };
        const reset = () => {
          s = 1;
          x = 0;
          y = 0;
        };
        // Con mouse la foto acercada se recorre moviendo el cursor (orilla del cursor = orilla de la foto)
        const follow = (p) => {
          const b = bounds();
          x = -(p.x / (stage.clientWidth / 2 || 1)) * b.x;
          y = -(p.y / (stage.clientHeight / 2 || 1)) * b.y;
          clamp();
        };
        const zoomAt = (p, scale) => {
          const cx = (p.x - x) / s;
          const cy = (p.y - y) / s;
          s = scale;
          x = p.x - s * cx;
          y = p.y - s * cy;
          clamp();
        };
        const toggle = (p, mouse) => {
          if (s > 1.01) reset();
          else if (mouse) {
            s = 2.2;
            follow(p);
          } else zoomAt(p, 2.5);
          render(true);
        };

        const show = (i, dir = 0) => {
          index = (i + items.length) % items.length;
          reset();
          render(false);
          // Primero la foto que ya cargó la página y luego la de alta resolución
          const slideImg = items[index].querySelector('img');
          if (slideImg?.currentSrc) img.src = slideImg.currentSrc;
          const hi = new Image();
          const want = index;
          hi.onload = () => {
            if (want === index) img.src = hi.src;
          };
          hi.src = items[index].dataset.zoomSrc;
          img.alt = slideImg?.alt || '';
          if (count) count.textContent = `${index + 1} / ${items.length}`;
          thumbs.forEach((thumb, i) => {
            const active = i === index;
            thumb.classList.toggle('is-active', active);
            thumb.setAttribute('aria-current', String(active));
            // La miniatura activa siempre queda a la vista dentro de la columna
            if (active && thumbList && thumbList.scrollHeight > thumbList.clientHeight) {
              thumbList.scrollTo({ top: thumb.offsetTop - thumbList.clientHeight / 2 + thumb.offsetHeight / 2, behavior: 'smooth' });
            }
          });
          if (dir && img.animate) {
            img.animate([{ opacity: 0, translate: `${dir * 40}px 0` }, { opacity: 1, translate: '0 0' }], { duration: 260, easing: 'ease-out' });
          }
        };
        const go = (step) => show(index + step, step);

        const open = (i) => {
          openedAt = i;
          show(i);
          dialog.showModal();
          document.documentElement.classList.add('bp-zoom-open');
          // La siguiente foto se precarga para que el cambio sea inmediato
          if (items.length > 1) new Image().src = items[(i + 1) % items.length].dataset.zoomSrc;
        };

        this.media.addEventListener('click', (event) => {
          const slide = event.target instanceof Element && event.target.closest('[data-zoom-src]');
          if (!slide || this.dragMoved) return;
          open(items.indexOf(slide));
        });

        dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('bp-zoom-open');
          pointers.clear();
          gesture = null;
          // Al cerrar, el slider de la página queda en la última foto vista
          if (index !== openedAt) this.goTo(this.slides.indexOf(items[index]));
        });
        dialog.querySelector('[data-bp-zoom-close]')?.addEventListener('click', () => dialog.close());
        dialog.querySelector('[data-bp-zoom-prev]')?.addEventListener('click', () => go(-1));
        dialog.querySelector('[data-bp-zoom-next]')?.addEventListener('click', () => go(1));
        thumbs.forEach((thumb, i) =>
          thumb.addEventListener('click', () => {
            if (i !== index) show(i, i > index ? 1 : -1);
          })
        );
        dialog.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') go(-1);
          if (event.key === 'ArrowRight') go(1);
        });
        dialog.addEventListener('wheel', (event) => event.preventDefault(), { passive: false });
        window.addEventListener('resize', () => {
          if (!dialog.open) return;
          clamp();
          render(false);
        });

        stage.addEventListener('pointerdown', (event) => {
          if (event.button > 0) return;
          stage.setPointerCapture(event.pointerId);
          const p = local(event);
          pointers.set(event.pointerId, p);
          if (pointers.size === 2) {
            const [a, b] = [...pointers.values()];
            gesture = { type: 'pinch', dist: Math.hypot(a.x - b.x, a.y - b.y) || 1, mid: { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 }, s, x, y };
          } else if (pointers.size === 1) {
            gesture = { type: 'drag', start: p, x, y, t: Date.now(), moved: false, axis: null, mouse: event.pointerType === 'mouse' };
          }
        });

        stage.addEventListener('pointermove', (event) => {
          const p = local(event);
          if (event.pointerType === 'mouse' && !pointers.size) {
            if (s > 1.01) {
              follow(p);
              render(false);
            }
            return;
          }
          if (!pointers.has(event.pointerId)) return;
          pointers.set(event.pointerId, p);

          if (gesture?.type === 'pinch' && pointers.size === 2) {
            const [a, b] = [...pointers.values()];
            const mid = { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 };
            const cx = (gesture.mid.x - gesture.x) / gesture.s;
            const cy = (gesture.mid.y - gesture.y) / gesture.s;
            s = Math.max(1, Math.min(MAX, (gesture.s * Math.hypot(a.x - b.x, a.y - b.y)) / gesture.dist));
            x = mid.x - s * cx;
            y = mid.y - s * cy;
            clamp();
            render(false);
            return;
          }
          if (gesture?.type !== 'drag') return;
          const dx = p.x - gesture.start.x;
          const dy = p.y - gesture.start.y;
          if (!gesture.moved && Math.hypot(dx, dy) > 6) {
            gesture.moved = true;
            gesture.axis = Math.abs(dx) >= Math.abs(dy) ? 'x' : 'y';
          }
          if (!gesture.moved) return;
          if (gesture.mouse) {
            if (s > 1.01) {
              follow(p);
              render(false);
            }
            return;
          }
          if (s > 1.01) {
            x = gesture.x + dx;
            y = gesture.y + dy;
            clamp();
          } else if (gesture.axis === 'x' && items.length > 1) {
            x = dx;
          } else if (gesture.axis === 'y') {
            y = Math.max(0, dy);
            dialog.style.setProperty('--bp-zoom-fade', String(Math.max(0.4, 1 - y / 500)));
          }
          render(false);
        });

        const end = (event) => {
          if (!pointers.has(event.pointerId)) return;
          const p = local(event);
          pointers.delete(event.pointerId);
          if (gesture?.type === 'pinch') {
            if (pointers.size === 1) {
              const [rest] = [...pointers.values()];
              gesture = { type: 'drag', start: rest, x, y, t: 0, moved: true, axis: null, mouse: false };
            } else if (!pointers.size) {
              gesture = null;
              if (s < 1.05) reset();
              else clamp();
              render(true);
            }
            return;
          }
          const g = gesture;
          gesture = null;
          if (!g || g.type !== 'drag') return;
          dialog.style.removeProperty('--bp-zoom-fade');

          if (!g.moved && event.type === 'pointerup' && Date.now() - g.t < 350) {
            if (g.mouse) return toggle(p, true);
            const now = Date.now();
            if (now - lastTap < 320) {
              lastTap = 0;
              toggle(p, false);
            } else lastTap = now;
            return;
          }
          if (g.mouse || s > 1.01) return;
          const dx = p.x - g.start.x;
          const dy = p.y - g.start.y;
          if (g.axis === 'y' && dy > 110) return dialog.close();
          if (g.axis === 'x' && Math.abs(dx) > 60 && items.length > 1) return go(dx < 0 ? 1 : -1);
          reset();
          render(true);
        };
        stage.addEventListener('pointerup', end);
        stage.addEventListener('pointercancel', end);
      }

      openMenu(index) {
        if (!this.menu) return;
        this.openMenuIndex = index;
        this.menuLists.forEach((list) => (list.hidden = Number(list.dataset.bpMenuList) !== index));
        this.barToggles.forEach((toggle) => toggle.setAttribute('aria-expanded', String(Number(toggle.dataset.bpBarToggle) === index)));
        // El panel flota justo arriba de la barra
        this.menu.style.setProperty('--bp-bar-height', `${this.bar.offsetHeight}px`);
        this.menu.classList.add('is-open');
        this.menu.setAttribute('aria-hidden', 'false');
      }

      closeMenu() {
        if (!this.menu || this.openMenuIndex == null) return;
        this.openMenuIndex = null;
        this.menu.classList.remove('is-open');
        this.menu.setAttribute('aria-hidden', 'true');
        this.barToggles.forEach((toggle) => toggle.setAttribute('aria-expanded', 'false'));
      }

      disconnectedCallback() {
        this.slideObserver?.disconnect();
      }

      get variant() {
        return this.variants.find((variant) => variant.options.every((value, index) => value === this.selected[index])) ?? null;
      }

      select(index, value) {
        if (this.selected[index] === value) return;
        const before = this.variantMedia();
        this.selected[index] = value;
        this.update(true);
        // Al cambiar el color el slider se mueve a la foto de ese color (cambiar solo la talla no lo mueve)
        const mediaId = this.variantMedia();
        if (mediaId && mediaId !== before) {
          const slideIndex = this.slides.findIndex((slide) => slide.dataset.mediaId === String(mediaId));
          if (slideIndex >= 0) this.goTo(slideIndex);
        }
      }

      // Foto de la variante elegida; si esa combinación no existe, la de cualquier variante del mismo color
      variantMedia() {
        if (this.variant) return this.variant.mediaId ?? null;
        const match = this.variants.find((v) => v.mediaId && v.options.some((value, i) => i !== this.sizeIndex && value === this.selected[i]));
        return match?.mediaId ?? null;
      }

      update(pushUrl) {
        const variant = this.variant;

        this.optionSets.forEach((set, index) => {
          const menuList = this.menuLists.find((list) => Number(list.dataset.bpMenuList) === index);
          const buttons = [...set.querySelectorAll('.bp__value'), ...(menuList ? menuList.querySelectorAll('.bp__value') : [])];
          buttons.forEach((button) => {
            const selected = button.dataset.value === this.selected[index];
            button.classList.toggle('is-selected', selected);
            button.setAttribute('aria-pressed', String(selected));
            // Tallas agotadas para el color elegido se ven tachadas
            const candidate = this.selected.map((value, i) => (i === index ? button.dataset.value : value));
            const match = this.variants.find((v) => v.options.every((value, i) => value === candidate[i]));
            button.classList.toggle('is-unavailable', !match || !match.available);
          });
          const label = set.querySelector('[data-bp-option-value]');
          if (label) label.textContent = this.selected[index] ?? '';
        });

        this.barToggles.forEach((toggle) => {
          const value = this.selected[Number(toggle.dataset.bpBarToggle)];
          const label = toggle.querySelector('[data-bp-bar-value]');
          if (label && value != null) label.textContent = value;
        });

        const available = Boolean(variant?.available);
        this.querySelectorAll('[data-bp-atc]').forEach((button) => {
          button.disabled = !available;
          button.querySelector('[data-bp-atc-label]').textContent = !variant ? 'No disponible' : available ? 'Agregar al carrito' : 'Agotado';
        });
        if (variant) {
          this.querySelectorAll('[data-bp-price]').forEach((price) => (price.textContent = variant.price));
          this.querySelectorAll('[data-bp-variant-input]').forEach((input) => (input.value = variant.id));
          if (pushUrl) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url);
          }
        }
      }

      // Foto activa: resalta miniatura (escritorio) y la rayita del carrusel (celular)
      watchSlides() {
        if (!this.slides.length) return;
        const ratios = new Map();
        this.slideObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => ratios.set(entry.target, entry.intersectionRatio));
            if (!this.desktop.matches) return;
            let best = 0;
            let bestRatio = -1;
            this.slides.forEach((slide, index) => {
              const ratio = ratios.get(slide) ?? 0;
              if (ratio > bestRatio) {
                bestRatio = ratio;
                best = index;
              }
            });
            if (bestRatio > 0) this.setActive(best);
          },
          { threshold: [0, 0.25, 0.5, 0.75, 1] }
        );
        this.slides.forEach((slide) => this.slideObserver.observe(slide));
      }

      setActive(index) {
        this.thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
        const thumb = this.thumbs[index];
        const list = thumb?.closest('.bp__thumbs');
        if (thumb && list && list.scrollHeight > list.clientHeight) {
          list.scrollTo({ top: thumb.offsetTop - list.clientHeight / 2 + thumb.offsetHeight / 2, behavior: 'smooth' });
        }
      }

      goTo(index) {
        const slide = this.slides[index];
        if (!slide) return;
        if (this.desktop.matches) {
          // En escritorio Horizon hace scroll dentro de .page-wrapper, no en la ventana
          slide.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          this.slideTo(index);
        }
      }

      // Celular: carrusel con el deslizado nativo del teléfono (scroll-snap)
      slideTo(index, smooth = true) {
        this.index = Math.max(0, Math.min(this.slides.length - 1, index));
        this.preload(this.index);
        this.media.scrollTo({ left: this.index * this.media.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
        this.setActive(this.index);
      }

      // Carga la foto actual y las de al lado para que no aparezcan en blanco al deslizar
      preload(index) {
        [index - 1, index, index + 1, index + 2].forEach((i) => {
          const img = this.slides[i]?.querySelector('img[loading="lazy"]');
          if (img) img.loading = 'eager';
        });
      }

      setupSwipe() {
        if (!this.media || this.slides.length < 2) return;
        if (!this.desktop.matches) this.preload(0);
        this.media.addEventListener(
          'scroll',
          () => {
            if (this.desktop.matches) return;
            const index = Math.round(this.media.scrollLeft / (this.media.clientWidth || 1));
            if (index === this.index) return;
            this.index = Math.max(0, Math.min(this.slides.length - 1, index));
            this.preload(this.index);
            this.setActive(this.index);
          },
          { passive: true }
        );
        // Con mouse (vista celular del editor en la compu) también se puede arrastrar
        let drag = null;
        this.media.addEventListener('pointerdown', (event) => {
          if (this.desktop.matches || event.pointerType !== 'mouse' || event.button !== 0) return;
          drag = { x: event.clientX, left: this.media.scrollLeft, moved: false };
          this.dragMoved = false;
          this.media.style.scrollSnapType = 'none';
          this.media.setPointerCapture(event.pointerId);
          event.preventDefault();
        });
        this.media.addEventListener('pointermove', (event) => {
          if (!drag) return;
          const dx = event.clientX - drag.x;
          if (Math.abs(dx) > 4) drag.moved = true;
          this.media.scrollLeft = drag.left - dx;
        });
        const endDrag = (event) => {
          if (!drag) return;
          const dx = event.clientX - drag.x;
          const start = Math.round(drag.left / (this.media.clientWidth || 1));
          const step = Math.abs(dx) > 40 ? (dx < 0 ? 1 : -1) : 0;
          this.dragMoved = drag.moved;
          drag = null;
          this.media.style.scrollSnapType = '';
          this.slideTo(start + step);
        };
        this.media.addEventListener('pointerup', endDrag);
        this.media.addEventListener('pointercancel', endDrag);
        // Al girar el teléfono o cambiar tamaño se mantiene la misma foto
        window.addEventListener('resize', () => {
          if (!this.desktop.matches) this.media.scrollTo({ left: this.index * this.media.clientWidth });
        });
      }

      // Barra flotante: se esconde cuando el botón real de agregar está en pantalla
      watchForm() {
        const pageButton = this.form?.querySelector('[data-bp-atc]');
        if (!this.bar || !pageButton) return;
        let frame = 0;
        const sync = () => {
          frame = 0;
          const viewport = window.innerHeight;
          const button = pageButton.getBoundingClientRect();
          const section = this.getBoundingClientRect();
          const buttonVisible = button.top < viewport && button.bottom > 0;
          // Se queda visible al seguir bajando, hasta el pie de página
          const show = !this.desktop.matches && !buttonVisible && section.top < viewport;
          if (!show) this.closeMenu();
          if (show === this.bar.classList.contains('is-visible')) return;
          this.bar.classList.toggle('is-visible', show);
          this.bar.setAttribute('aria-hidden', String(!show));
          this.bar.querySelectorAll('button').forEach((el) => (el.tabIndex = show ? 0 : -1));
        };
        const schedule = () => {
          if (!frame) frame = requestAnimationFrame(sync);
        };
        document.addEventListener('scroll', schedule, { passive: true, capture: true });
        window.addEventListener('resize', schedule);
        this.desktop.addEventListener('change', schedule);
        sync();
      }

      async add(button) {
        const variant = this.variant;
        if (!variant || !variant.available || this.busy) return;
        this.busy = true;
        this.querySelectorAll('[data-bp-atc]').forEach((b) => b.setAttribute('data-loading', ''));
        if (this.status) this.status.textContent = '';

        try {
          const root = window.Shopify?.routes?.root || '/';
          const sectionIds = [...document.querySelectorAll('cart-items-component')]
            .map((element) => element.dataset.sectionId)
            .filter(Boolean);

          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: variant.id, quantity: 1 }],
              sections: sectionIds.join(','),
              sections_url: window.location.pathname,
            }),
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message || 'No se pudo agregar');

          const cart = await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json();
          await this.announceCartUpdate(variant, cart, data.sections);
        } catch (error) {
          if (this.status) this.status.textContent = error.message;
        } finally {
          this.busy = false;
          this.querySelectorAll('[data-bp-atc]').forEach((b) => b.removeAttribute('data-loading'));
        }
      }

      // Avisa al tema (Horizon) que se agregó un producto: actualiza el carrito, el contador y abre el cajón
      async announceCartUpdate(variant, cart, sections) {
        try {
          const { CartLinesUpdateEvent } = await import('@shopify/events');
          const deferred = CartLinesUpdateEvent.createPromise();
          this.dispatchEvent(
            new CartLinesUpdateEvent({
              action: 'add',
              context: 'product',
              lines: [{ merchandiseId: String(variant.id), quantity: 1 }],
              promise: deferred.promise,
            })
          );
          deferred.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: {
              items: cart.items,
              source: 'bendito-product',
              itemCount: 1,
              sections,
              didError: false,
            },
          });
        } catch (_) {
          document.querySelectorAll('cart-icon').forEach((icon) => icon.renderCartBubble?.(cart.item_count));
          document.getElementById('cart-drawer')?.open?.();
        }

        setTimeout(() => {
          const drawer = document.getElementById('cart-drawer');
          if (drawer && !drawer.hasAttribute('open')) drawer.open?.();
        }, 600);
      }
    }

    customElements.define('bendito-product', BenditoProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
